import { Controller } from "remult";

@Controller("sub-category-field-config-methods")
export class SubCategoryFieldConfigMethods {}
